
import { defineComponent, ref, reactive, toRefs, onMounted, warn, watch, nextTick } from 'vue'
import { ArrowUpOutlined, ArrowDownOutlined, DownOutlined, UpOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import f10Api from '@/api/f10Api'
import globalsets from '../utils/globalsets'
import ws from '../websocket/index'
export default defineComponent({
  components: { DownOutlined, UpOutlined },
  props: {
    token: {
      type: String,
      default: function () {
        return ''
      }
    },
    theme: {
      type: String,
      default: function () {
        return ''
      }
    }
  },
  setup(props: any, context) {
    const route = useRoute()
    const pageData: any = reactive({
      anchorbg: require('@/assets/anchorbg.png'),
      lis: [],
      nav: [],
      currentli: '',
      activeIndex: '',
      target: () => document.querySelector('.wrapper'),
      isOpen: true,
      currentshares: {
        LastPrice: 0,
        RiseandFall: 0,
        PreClosePrice: 0,
        increase: 0,
        InstrumentID: '',
        name: '',
        key: new Date().getTime() + ''
      },
      websock: null
    })
    pageData.lis = [
      {
        key: 'zxdt',
        name: '最新动态'
      },
      {
        key: 'gszl',
        name: '公司资料'
      },
      {
        key: 'gdyj',
        name: '股东研究'
      },
      {
        key: 'jyfx',
        name: '经营分析'
      },
      {
        key: 'gbjg',
        name: '股本结构'
      },
      {
        key: 'ylyc',
        name: '盈利预测'
      },
      {
        key: 'gsgg',
        name: '公司高管'
      },
      {
        key: 'cwfx',
        name: '财务分析'
      },
      {
        key: 'fhrz',
        name: '分红融资'
      },
      {
        key: 'gsds',
        name: '公司大事'
      },
      {
        key: 'hydb',
        name: '行业对比'
      },
      {
        key: 'ggkd',
        name: '公告看点'
      }
    ]
    function selecthash(e: any, link: any) {
      e.preventDefault()
    }
    ws.websocket.safeSubscribeDYNA(route.query.code, route.query.market)
    ws.websocket.on('onMessage', msg => {
      const _data = msg.QuoteData
      console.log('打印监听数据===666', _data)
      if (_data && _data.StatisticsData && (_data.StatisticsData || []).length > 0) {
        pageData.currentshares.PreClosePrice = _data.StatisticsData[0].PreClosePrice
        pageData.currentshares.InstrumentID = _data.StatisticsData[0].InstrumentID
      }
      if (_data && _data.StaticData && (_data.StaticData || []).length > 0) {
        pageData.currentshares.name = _data.StaticData[0].InstrumentName
        context.emit('currentshares', pageData.currentshares)
      }
      if (_data && _data.DynaData && (_data.DynaData || []).length > 0) {
        pageData.currentshares.LastPrice = _data.DynaData[0].LastPrice || null
      }
      if (_data && (_data.InstStatusData || [])[0]) {
        pageData.currentshares.InstStatus = ((msg.QuoteData.InstStatusData || [])[0] || {}).StatusType
      }
      // 停牌
      if (pageData.currentshares.InstStatus === 6) {
        pageData.currentshares.RiseandFall = null
        pageData.currentshares.increase = null
        pageData.currentshares.LastPrice = null
      } else {
        pageData.currentshares.RiseandFall = pageData.currentshares.LastPrice - pageData.currentshares.PreClosePrice
        pageData.currentshares.increase =
          ((pageData.currentshares.LastPrice - pageData.currentshares.PreClosePrice) / pageData.currentshares.PreClosePrice) * 100
      }
    })
    // 点击 li
    function changenav(item: any) {
      pageData.currentli = item.key
      const softNameAbbr = route.query.softNameAbbr as string
      const versionStr: any = route.query.version || ''
      const version = parseFloat(versionStr.split('.').join('') || '0')
      /**
       * key 值尽量不修改，如有修改，需要通知原生修改跳转连接
       * H5项目 需求 ID ID1109794
       */
      switch (item.key) {
        case 'zxdt':
          pageData.nav = [
            {
              key: 'gsgy',
              title: '公司概要',
              seemore: false
            },
            {
              key: 'zxzb',
              title: '最新指标',
              seemore: 'seemore',
              seemoredesc: '查看更多',
              target: 'cwfx,zyzb'
            },
            {
              key: 'jqzysj',
              title: '近期重要事件',
              seemore: false
            },
            {
              key: 'gsgg',
              title: '公司公告',
              seemore: false
            },
            {
              key: 'gdfx',
              title: '股东分析',
              seemore: 'seemore',
              seemoredesc: '查看更多',
              target: 'gdyj,gdrs'
            },
            {
              key: 'lhbd',
              title: '龙虎榜单',
              seemore: (['jfztADV', 'jfzt']).indexOf(softNameAbbr) > -1 ? 'seedetail' : false
            },
            {
              key: 'dzjy',
              title: '大宗交易',
              seemore: (['jfztADV', 'jfzt']).indexOf(softNameAbbr) > -1 ? 'seedetail' : false
            },
            {
              key: 'rzrq',
              title: '融资融券',
              seemore: (['jfztADV', 'jfzt']).indexOf(softNameAbbr) > -1 ? 'seedetail' : false
            }
          ]
          getlatest()
          break
        case 'gszl':
          pageData.nav = [
            {
              key: 'xxqk',
              title: '详细情况'
            },
            {
              key: 'fxxg',
              title: '发行相关'
            }
          ]
          getorginfo()
          break
        case 'gdyj':
          pageData.nav = [
            {
              key: 'gdrs',
              title: '股东人数'
            },
            {
              key: 'sdltgd',
              title: '十大流通股东'
            },
            {
              key: 'sdgd',
              title: '十大股东'
            },
            {
              key: 'jgcc',
              title: '机构持仓'
            },
            {
              key: 'sdgdcgbd',
              title: '十大股东持股变动'
            },
            {
              key: 'jjcg',
              title: '基金持股',
              // seemore: 'seedetail',
              seemore: (['jfztGW', 'jfzt', 'jfztADV']).indexOf(softNameAbbr) > -1 ? 'seedetail' : false,
              seemoredesc: '个股主力持仓'
            },
            {
              key: 'xsjj',
              title: '限售解禁'
            }
          ]
          getholderresearch()
          break

        case 'jyfx':
          pageData.nav = [
            {
              key: 'zyjs',
              title: '主营介绍'
            },
            {
              key: 'zygcfx',
              title: '主营构成分析'
            },
            {
              key: 'jyps',
              title: '经营评述'
            }
          ]
          getbusinessanalysis()
          break
        case 'gbjg':
          pageData.nav = [
            {
              key: 'xsjjDetail',
              title: '限售解禁'
            },
            {
              key: 'gbjg',
              title: '股本结构'
            },
            {
              key: 'lngbbd',
              title: '历年股本变动'
            }
          ]
          getcapitalstructure()
          break
        case 'ylyc':
          pageData.nav = [
            {
              key: 'yjyc',
              title: '业绩预测'
            },
            {
              key: 'ycmx',
              title: '预测明细'
            },
            {
              key: 'xxzbyc',
              title: '详细指标预测'
            },
            {
              key: 'ybpj',
              title: '研报评级'
            }
          ]
          getprofitforecast()
          break
        case 'gsgg':
          pageData.nav = [
            {
              key: 'gglb',
              title: '高管列表'
            },
            {
              key: 'ggjxgrycgbd',
              title: '高管及相关人员持股变动',
              seemore: softNameAbbr === 'jfztADV' && version >= 370 ? 'seedetail' : false,
              seemoredesc: '高管增减持明细'
            }
          ]
          getleadershare()
          break
        case 'cwfx':
          pageData.nav = [
            {
              key: 'zyzb',
              title: '主要指标'
            },
            {
              key: 'dbfx',
              title: '杜邦分析'
            },
            {
              key: 'zcfzb',
              title: '资产负债表'
            },
            {
              key: 'lrb',
              title: '利润表'
            },
            {
              key: 'xjllb',
              title: '现金流量表'
            },
            {
              key: 'bfbbb',
              title: '百分比报表'
            },
            {
              key: 'cwbg',
              title: '财务报告'
            }
          ]
          getFinanceF10()
          break
        case 'fhrz':
          pageData.nav = [
            {
              key: 'fhqk',
              title: '分红情况'
            },
            {
              key: 'lnfhrz',
              title: '历年分红融资'
            },
            {
              key: 'zfmx',
              title: '增发明细'
            },
            {
              key: 'pgmx',
              title: '配股明细'
            }
          ]
          getMarginF10DividendFinance()
          break
        case 'gsds':
          pageData.nav = [
            {
              key: 'jqzysjDetail',
              title: '近期重要事件'
            },
            {
              key: 'zdsx',
              title: '重大事项'
            },
            {
              key: 'ggjxgrycgbdDetail',
              title: '高管及相关人员持股变动',
              seemore: softNameAbbr === 'jfztADV' && version >= 370 ? 'seedetail' : null,
              seemoredesc: '高管增减持明细'
            },
            {
              key: 'sdgdcgbdDetail',
              title: '十大股东持股变动'
            },
            {
              key: 'lhbdDetail',
              title: '龙虎榜单',
              seemore: (['jfztADV', 'jfzt']).indexOf(softNameAbbr) > -1 ? 'seedetail' : false
            },
            {
              key: 'dzjyDetail',
              title: '大宗交易',
              seemore: (['jfztADV', 'jfzt']).indexOf(softNameAbbr) > -1 ? 'seedetail' : false
            },
            {
              key: 'rzrqDetail',
              title: '融资融券',
              seemore: (['jfztADV', 'jfzt']).indexOf(softNameAbbr) > -1 ? 'seedetail' : false
            }
          ]
          getBigevent()
          break
        case 'hydb':
          pageData.nav = [
            {
              key: 'hydw',
              title: '行业地位'
            },
            {
              key: 'hykd',
              title: '行业看点'
            }
          ]
          getInfoF10IndustryComparison()
          break
        case 'ggkd':
          pageData.nav = [
            {
              key: 'dyhd',
              title: '调研活动'
            },
            {
              key: 'gskd',
              title: '公司看点'
            },
            {
              key: 'gsggDetail',
              title: '公司公告'
            },
            {
              key: 'yjbg',
              title: '研究报告'
            },
            {
              key: 'tzzhd',
              title: '投资者互动',
              seemore: softNameAbbr === 'jfztADV' && version >= 370 ? 'seedetail' : null,
              seemoredesc: '更多投资者互动'
            }
          ]
          getnewsnotice()
          break
      }
      pageData.key = new Date().getTime() + ''
      context.emit('setnav', pageData.nav)
    }
    function changehash(e: any) {
      pageData.activeIndex = e.split('#')[1]
    }
    function getlatest() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getlatest(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 详细情况
    function getorginfo() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        ExchangeID: route.query.market,
        InstrumentID: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getorginfo(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 股东研究
    function getholderresearch() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getholderresearch(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 经营分析
    function getbusinessanalysis() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getbusinessanalysis(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 股本结构
    function getcapitalstructure() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getcapitalstructure(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 高管列表
    function getleadershare() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getleadershare(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 盈利预测
    function getprofitforecast() {
      const data: any = {}
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getprofitforecast(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    function getnewsnotice() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getnewsnotice(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 行业对比
    function getInfoF10IndustryComparison() {
      const data: any = {}
      // 0：日期（默认），1：股票ID，2：评价，3：变动（1为首次,2为调高,3为调低,4为维持），4：目标价，5：机构，6：作者
      // 0:desc（默认）,1:asc
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getInfoF10IndustryComparison(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 财务分析
    function getFinanceF10() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        DataType: 31,
        StaticsType: 1
      }
      data.headers = {
        token: props.token
      }
      f10Api.getFinanceF10(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 分红融资
    function getMarginF10DividendFinance() {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getMarginF10DividendFinance(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 公司大事
    function getBigevent() {
      const data: any = {}
      data.data = {
        Exch: ((route.query.market as string) || '').toLowerCase(),
        Inst: route.query.code
      }
      data.headers = {
        token: props.token
      }
      f10Api.getBigevent(data).then((res: any) => {
        context.emit('getPageData', res.Data)
      })
    }
    // 此处根据query 判断，跳到对应的页面 route.query.topnav
    const topnav = route.query.topnav
    const index = topnav ? pageData.lis.findIndex((item: any) => item.key === topnav) : '0'
    changenav(pageData.lis[index])
    function setcurrentli(data: any) {
      changenav(data)
      nextTick(() => {
        setTimeout(() => {
          const index = pageData.nav.findIndex((item: any) => item.key === data.itemkey)
          const dom: any = document.querySelectorAll('.ant-anchor-link-title')
          dom[index].click()
        }, 300)
      })
    }
    watch(
      () => pageData.isOpen,
      () => {
        context.emit('isopen', pageData.isOpen)
      }
    )
    return {
      ...toRefs(pageData),
      selecthash,
      changenav,
      changehash,
      setcurrentli,
      getNumber: globalsets.getNumber,
      getPencent: globalsets.getPencent,
      getNumber2: globalsets.getNumber2
    }
  }
})
